import React, { useEffect, useState } from 'react';
import {
  Container,
  Paper,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';
import MachineMappingDashboard from './components/MachineMappingDashboard';
import RecipeDashboard from './components/RecipeDashboard';
import SLADashboard from './components/SLADashboard';
import TestDescriptionDashboard from './components/TestDescriptionDashboard';
import TestToAnalyst from './components/TestToAnalyst';
import AnalystDetails from './components/AnalystDetails';
import { mixpanelTrackTabs } from '../../mixPanelFunctions/mixPanelFunctions';

const MasterSheet = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const dashboardComponents = [
    // <AnalystDashboard />,
    <TestToAnalyst />,
    <MachineMappingDashboard />,
    <RecipeDashboard />,
    <SLADashboard />,
    <TestDescriptionDashboard />,
    <AnalystDetails />
  ];
 
  useEffect(()=>{
    if(dashboardComponents && dashboardComponents?.length > 0){
      mixpanelTrackTabs(dashboardComponents[selectedTab]?.type?.name,"master sheet");
    }
  },[selectedTab])

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        MasterSheet
      </Typography>
      <Tabs
        value={selectedTab}
        onChange={(event, newValue) => setSelectedTab(newValue)}
        indicatorColor="primary"
      >
        {/* <Tab label="Analyst Mapping" /> */}
        <Tab label="Test to Analyst" />
        <Tab label="Test to Machines" />
        <Tab label="Recipes" />
        <Tab label="SLA" />
        <Tab label="Test Descriptions" />
        <Tab label="Analyst Details" />
      </Tabs>
      <Paper elevation={3} sx={{ padding: 2 }}>
        {dashboardComponents[selectedTab]}
      </Paper>
    </Container>
  );
};

export default MasterSheet;
